export const ALLOWED_KEYS = [
  "q",
  "w",
  "e",
  "r",
  "t",
  "y",
  "u",
  "i",
  "o",
  "p",
  "a",
  "s",
  "d",
  "f",
  "g",
  "h",
  "j",
  "k",
  "l",
  "enter",
  "z",
  "x",
  "c",
  "v",
  "b",
  "n",
  "m",
  "backspace",
];

export const LETTER_STATES = {
  absent: "absent",
  correct: "correct",
  present: "present",
};
export const GAME_STATUS = {
  inProgress: "inProgress",
  completed: "completed",
};
